export const environment = {
    production: false,
    apiUrl: "https://scale.livepick.ai/",
    AzureRedirectUri: "https://scale.app.livepick.ai",
    google_auth_client_id: "1088177631529-2p71qppqsetlg6aospbniqh8bn72e2gf.apps.googleusercontent.com",
    generatePhotoUrl: "https://eu.ui-avatars.com/api/?background=DFD22B&color=fff&name=",
    socketUrl : "wss://scale.livepick.ai:5677/",
    facebook_auth_client_id: "357359291637009",
  };
  